<mp-header-nav>
  <mp-header-nav-element [navLink]="rootModuleLink()" [exact]="exact()" (activated)="activated.emit()">
    <span class="text-base">{{ label() }}</span>
  </mp-header-nav-element>
</mp-header-nav>
